// eslint-disable-next-line max-len
import { CustomStatusLabelStatus } from '@sdir/blueprint.aps/lib/components/Atoms/CustomStatusLabel';
import { ApplicationStatus } from '../constants/enums';

export const getStatusLabelVariant = (status: string): CustomStatusLabelStatus => {
  switch (status) {
    case ApplicationStatus.Draft:
    case ApplicationStatus.DraftConfirmed:
    case ApplicationStatus.QASample:
    case ApplicationStatus.Payment:
      return CustomStatusLabelStatus.New;
    case ApplicationStatus.Approved:
      return CustomStatusLabelStatus.Done;
    case ApplicationStatus.Rejected:
      return CustomStatusLabelStatus.Rejected;
    case ApplicationStatus.RequestMoreInformation:
      return CustomStatusLabelStatus.Waiting;
    case ApplicationStatus.CheckQualification:
    case ApplicationStatus.ManualProcessing:
      return CustomStatusLabelStatus.Response;
    default:
      return CustomStatusLabelStatus.New;
  }
};

export const getStatusLabelText = (status: string): string => {
  switch (status) {
    case ApplicationStatus.Draft:
    case ApplicationStatus.DraftConfirmed:
    case ApplicationStatus.QASample:
      return 'New application';
    case ApplicationStatus.Payment:
      return 'Ready for payment';
    case ApplicationStatus.Approved:
      return 'Approved';
    case ApplicationStatus.Rejected:
      return 'Rejected';
    case ApplicationStatus.RequestMoreInformation:
      return 'Awaiting clarification';
    case ApplicationStatus.CheckQualification:
    case ApplicationStatus.ManualProcessing:
      return 'Processing';
    default:
      return 'New application';
  }
};
